import { useEffect, useRef } from "react";
import { api } from "@/lib/api";

// Handles the return trip from Emergent Google OAuth.
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(window.location.hash.replace(/^#/, "")).get("session_id");
    if (!sid) {
      window.location.replace("/admin");
      return;
    }
    api
      .post("/auth/session", null, { headers: { "X-Session-ID": sid } })
      .then(() => window.location.replace("/admin"))
      .catch((e) => {
        const msg = e?.response?.data?.detail || "Login failed";
        window.location.replace("/admin?autherror=" + encodeURIComponent(msg));
      });
  }, []);

  return (
    <div className="min-h-[60vh] flex items-center justify-center bg-background">
      <p className="text-white/60 uppercase tracking-[0.25em] text-sm">Signing you in…</p>
    </div>
  );
}
